import Vue from 'vue'
import VueRouter from 'vue-router'

import security from '@/security/index'

Vue.use(VueRouter)

import routes from './routes.js'

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let nextPath = security.getNextPath(to)
  if (null === nextPath) {
    document.title = to.meta.title
    next()
  } else {
    next(nextPath)
  }
})

export default router